// Internal modules
import { features } from '@/lib';

const getFooterLegalLinks = (country, region) => {
  const footerLinksMap = features.get('footerLinks');

  return (
    footerLinksMap[country] || footerLinksMap[region] || footerLinksMap.DEFAULT
  );
};

export { getFooterLegalLinks };
